import { render } from "./DetailsSwiper.vue?vue&type=template&id=4a9db2f4&scoped=true"
import script from "./DetailsSwiper.vue?vue&type=script&lang=js"
export * from "./DetailsSwiper.vue?vue&type=script&lang=js"

import "./DetailsSwiper.vue?vue&type=style&index=0&id=4a9db2f4&scoped=true&lang=css"

import exportComponent from "C:\\_TimetipCode\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a9db2f4"]])

export default __exports__